// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"cbcda367","141":"90ce87eb","236":"24993ef5","324":"e3a0c065","453":"2b555ccd","484":"4f99beca","578":"bda05519","666":"b3c400cc","682":"65b3ae88","745":"e3ebc837","756":"5d4f64a3","832":"32deca48","888":"b2fb48d5"}[chunkId] + ".chunk.js";
};